module.exports = __webpack_public_path__ + "img/ltkbeauty-4x.4856272.jpg";